import { createAppStore } from '@store/createAppStore';
import { FactoringCompanyDetailsStore } from '@store/factoringCompany/factoringCompanyDetails/types';

import { FACTORING_COMPANY_INITIAL_OBJECT } from './constants';

const [factoringCompanyDetailsStore, setFactoringCompanyDetailsStore] =
  createAppStore<FactoringCompanyDetailsStore>(
    {
      isLoading: false,
      isError: false,
      factoringCompanyDetails: FACTORING_COMPANY_INITIAL_OBJECT,
      creationMode: false,
      factoringCompanyDetailsErrors: null,
      isDocumentsLoading: false,
      documents: [],
    },
    'factoringCompanyDetailsStore',
  );

export { factoringCompanyDetailsStore, setFactoringCompanyDetailsStore };
